/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';

import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

import * as overrides from '../../operation-overrides/getLinkedResourcesOverrides';
import type { GetLinkedResourcesQueryParams } from '../../operation-overrides/getLinkedResourcesOverrides';

export type GetLinkedResourcesPathParams = NonNullable<operations['getLinkedResources']['parameters']['path']>;
export type { GetLinkedResourcesQueryParams };

export interface Input extends GetLinkedResourcesPathParams {
  apiVersion?: string;
  query?: GetLinkedResourcesQueryParams;
}

export async function getLinkedResources(
  { apiVersion, query, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().GET('/api/v2/projects/{projectKey}/views/{viewKey}/linked/{resourceType}', {
    params: {
      path,
      // @ts-ignore We explicitly ignore errors here because we know the types may not match the spec
      query,
    },
    // @ts-ignore We explicitly ignore errors here because we know the types may not match the spec
    querySerializer: overrides.querySerializer,
    headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
    signal,
  });
}
